const theme = {
  colors: {
    brand: [
      "#ffedff",
      "#f7d9f6",
      "#e9b2e7",
      "#dc88d8",
      "#d065cb",
      "#c94ec3",
      "#c642c0",
      "#af33a9",
      "#9d2b98",
      "#892085"
    ],
    secondary: [
      "#fff5e2",
      "#ffeacd",
      "#fcd39d",
      "#fabb69",
      "#f8a73e",
      "#f79a22",
      "#f79311",
      "#dc7f03",
      "#c47100",
      "#ab6000"
    ],
    tertiary: [
      "#e2fef8",
      "#d2f7ef",
      "#abecdd",
      "#81e1ca",
      "#5dd8ba",
      "#45d2b0",
      "#35cfab",
      "#22b795",
      "#0fa384",
      "#008d71"
    ],
  },
  fontSizes: {
    xs: '.8rem',
    sm: '1rem',
    md: '1.13rem',
    lg: '1.2rem',
    xl: '1.3rem',
  },
  fontFamily: 'proxima-nova, "Helvetica Neue", helvetica, arial, sans-serif',
  primaryColor: 'brand',
  autoContrast: true,
  primaryShade: { light: 6, dark: 5 },
};


export default theme;
